import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { WatcherOptionEntity } from '../../../domain/entities/watcher-option.entity';

@Injectable({ providedIn: 'root' })
export class GetInvestigationWatcherOptionsUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(investigationId: string): Observable<WatcherOptionEntity[]> {
    return this._repository.getWatcherOptions(investigationId);
  }
}
